import { JSX } from "react";
import { toast } from "react-toastify";

function dismissReportQueued(): void {
  toast.dismiss();
}

function toastReportQueued(reportName: string, redirectOnDismiss: () => void): void {
  toast.info(
    <ReportQueuedToastBody reportName={reportName} />,
    {
      closeOnClick: true,
      containerId: "z-index-9999",
      draggable: false,
      onClose: () => {
        redirectOnDismiss();
      },
    });
}

function ReportQueuedToastBody(props: { reportName: string }): JSX.Element {
  return (
    <span>{props.reportName || "Requested report"} < br /> has been queued for generation, check < br /> email / Reports page for status.</span>
  );
}

export {
  dismissReportQueued as dismiss,
  toastReportQueued as toastInfo,
};
